export const countActiveFilters = (filters) => {
  let count = 0;

  if (filters.odds.minOdds !== null || filters.odds.maxOdds !== null) {
    count++;
  }

  if (filters.markets && filters.markets.length > 0) {
    count++;
  }

  if (filters.date.length > 0) {
    count++;
  }

  if (
    filters.fixtures.today.length > 0 ||
    filters.fixtures.tomorrow.length > 0
  ) {
    count++;
  }

  // Note: stats and sortBy are not counted as they have default values and are always "set"
  // stats defaults to "last5" and sortBy defaults to "stats-desc"

  return count;
};
